<template>
    <div v-if="show" id="loader">
        <div class="content">
            <DotLoader></DotLoader>
            <span class="info">
                <slot></slot>
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "LoaderDialog",
        props: ['show', 'message']
    }
</script>

<style lang="scss" scoped>
    #loader {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background: #ffffff95;

        .content {
            position: absolute;
            height: 300px;
            width: 450px;
            background: #ffffff;
            box-shadow: 0 2px 8px #00000054;
            margin: auto;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            display: flex;
            flex-flow: column;
            align-items: center;
            text-align: center;
            justify-content: center;
            padding: 2em;

            .info {
                font-size: large;
                line-height: 30px;
                margin-top: 50px;
            }
        }
    }
</style>